module.exports = __webpack_public_path__ + "static/media/new.be12074a.jpg";